export enum GroupServerErrorCode {
  GroupIsUnavailable = 'E_GROUP_IS_UNAVAILABLE',
  GroupDoesNotExist = 'E_GROUP_DOES_NOT_EXIST',
  GroupTypeIsInvalid = 'E_INVALID_GROUP_TYPE',
  GroupTypeIsUnsupported = 'E_UNSUPPORTED_GROUP_TYPE',
  UserIsNotBannedInTheGroup = 'E_USER_IS_NOT_BANNED_IN_THE_GROUP',
  UserIsBannedInTheGroup = 'E_USER_IS_BANNED_IN_THE_GROUP',
  ParticipantNotInGroup = 'E_PARTICIPANT_NOT_IN_GROUP',
  InvitationsTooManyToRemove = 'E_INVITATIONS_TOO_MANY_PHONES_TO_REMOVE',
  InvitationsTooManyToAdd = 'E_INVITATIONS_TOO_MANY_PHONES_TO_ADD',
  UserGroupRelationshipDoesNotExist = 'E_USER_GROUP_RELATIONSHIP_DOES_NOT_EXIST',
  InvitationsToManyAdminsToAdd = 'E_INVITATIONS_TOO_MANY_ADMINS_TO_ADD',
  PinnedChannelsLimit = 'E_PINNED_CHANNELS_LIMIT',
  PinnedGroupsLimit = 'E_PINNED_GROUPS_LIMIT',
  P2PIsWrong = 'E_WRONG_P2P_CHAT',
  DeepLinkIsTaken = 'E_DEEP_LINK_TAKEN',
  DeepLinkBadData = 'E_DEEP_LINK_BAD_DATA',
  E2eeCommitSyncRequired = 'E_E2E_COMMIT_SYNC_REQUIRED',
  UnsupportedChatType = 'unsupportedChatType',
  InvalidChatType = 'invalidChatType',
}
